export default "__VITE_ASSET__CrXpkAQn__"